import * as Meetings from './meetings.json'
import * as NoData from './no-data-error.json'
import * as Bye from './bye.json'
import * as Hi from './hi.json'

export {Meetings,NoData,Bye, Hi}